module.exports = __webpack_public_path__ + "static/media/FENGYUN 4A.6ff4f806.czml";